import { AutogenLayoutdpLicense } from "./autogen/AutogenLayoutdpLicense";
import { Api } from "@mcleod/core";


export class dpLicense extends AutogenLayoutdpLicense {

    override async onLoad() {
        await this.CheckLicenses();
    }

    private async CheckLicenses()
    {
        const module: string = "mcleodui";
        let st: boolean = false;
        try {
            await Api.post("imaging-services/imglicserver", {action: "check",
                            module: module}).then(response => {
                if( response )
                {
                    st = response.data[0].licensed >= 1 && response.data[0].licensed <= 3 ? true : false;
                    this.textboxLicUsed.text = response.data[0].usedlics;
                    this.textboxTotLics.text = response.data[0].totlics;
                }
            });
        } finally {
            //CommonDialogs.showMessage("Failed to check module..." , "Document Power");
        }

        return( st );
    }

}
